import { avatar, logo, logoSymbol, logoWhite } from "@/assets";
import { sideNav } from "@/constants";
import { CgSearch } from "react-icons/cg";
import { FiLogOut } from "react-icons/fi";
import { cn } from "@/lib/utils";

import { useState } from "react";
import Footer from "./Footer";
import { Link, useLocation } from "react-router-dom";
import { HiOutlineAcademicCap, HiOutlineHome } from "react-icons/hi2";
import { useTheme } from "@/hooks/useTheme";
import { BsCart } from "react-icons/bs";
import { MdOutlineGeneratingTokens } from "react-icons/md";
import { AiOutlineDollar } from "react-icons/ai";
import { IoReceiptOutline, IoSettingsOutline } from "react-icons/io5";
import { GoChevronDown } from "react-icons/go";
import { useSelector } from "react-redux";
import { IoIosPeople } from "react-icons/io";
import { useMediaQuery } from "react-responsive";

const SideNavbar = () => {
  const [active, setActive] = useState("home");
  const location = useLocation();
  const { theme } = useTheme();
  const pathname = location.pathname;
  const realPathname = pathname.split("/")[2];
  const [closeTab, setCloseTab] = useState(false);
  const user = useSelector((state) => state.user.user);

  return (
    <nav className={`flex h-[100dvh] flex-col justify-between px-3 pt-5 pb-2`}>
      <div className="flex-1">
        <div className="flex cursor-pointer items-center gap-x-1">
          <img src={logoSymbol} alt="logo" className="w-8" />

          <div className="flex w-full items-end gap-1">
            <h2 className="font-righteous text-2xl font-medium text-black/85 dark:text-white">
              Billzpay
            </h2>

            <span className="text-xs font-bold">V2.0</span>
          </div>
        </div>

        <div className="no-scrollbar mt-5 flex flex-col gap-2 overflow-y-auto">
          <Link
            to="/dashboard"
            className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
              "bg-blue-100 dark:bg-[#d7eded29]": pathname === "/dashboard",
              "hover:bg-gray-100 hover:dark:bg-gray-800":
                pathname !== "/dashboard",
            })}
            onClick={() => setActive("home")}
          >
            <HiOutlineHome
              size={21}
              className="text-black/85 dark:text-[#CDE9DF]"
            />
            <h3 className="text-base font-semibold">Home</h3>
          </Link>

          {sideNav.map((link, index) => (
            <Link
              to={link.route}
              key={index}
              onClick={() => {
                setActive(link.name.toLowerCase());
                scrollTo(0, 0);
                setCloseTab(false);
              }}
              className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
                "text-primary bg-[#edf8f3] dark:bg-[#d7eded29]":
                  link.route === realPathname,
                "hover:bg-gray-100 hover:dark:bg-gray-800":
                  link.route !== realPathname,
              })}
            >
              <link.icon
                size={21}
                className="text-black/85 dark:text-[#CDE9DF]"
              />

              <h3 className="text-base font-semibold dark:text-white">
                {link.name}
              </h3>
            </Link>
          ))}

          <div className="flex flex-col gap-1">
            <div
              onClick={() => setCloseTab((prev) => !prev)}
              className={cn("flex items-center rounded-lg px-3 py-2.5", {
                "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                  realPathname === "order-history" ||
                  realPathname === "buy-exam-pins",
                "hover:bg-gray-100 hover:dark:bg-gray-800":
                  realPathname !== "order-history",
              })}
            >
              <div className={cn("flex flex-1 items-center gap-2")}>
                <HiOutlineAcademicCap
                  size={21}
                  className="text-black/85 dark:text-[#CDE9DF]"
                />

                <h3 className="text-base font-semibold">Exam Pins & Tokens</h3>
              </div>

              <GoChevronDown />
            </div>

            {closeTab && (
              <div
                onClick={() => setCloseTab(false)}
                className="flex flex-col gap-1"
              >
                <Link
                  to="/dashboard/buy-exam-pins"
                  className={cn(
                    "ml-5 flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "buy-exam-pins",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "buy-exam-pins",
                    },
                  )}
                  onClick={() => setActive("buy-exam-pins")}
                >
                  <MdOutlineGeneratingTokens
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold">Buy Pins & Tokens</h3>
                </Link>

                <Link
                  to="/dashboard/order-history"
                  className={cn(
                    "ml-5 flex items-center gap-2 rounded-lg px-3 py-2.5",
                    {
                      "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                        realPathname === "order-history",
                      "hover:bg-gray-100 hover:dark:bg-gray-800":
                        realPathname !== "order-history",
                    },
                  )}
                  onClick={() => setActive("order-history")}
                >
                  <BsCart
                    size={21}
                    className="text-black/85 dark:text-[#CDE9DF]"
                  />
                  <h3 className="text-base font-semibold">Order History</h3>
                </Link>
              </div>
            )}
          </div>

          {/* Beneficiary */}
          <Link
            to="/dashboard/beneficiaries"
            className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
              "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                realPathname === "beneficiary",
              "hover:bg-gray-100 hover:dark:bg-gray-800":
                realPathname !== "beneficiary",
            })}
            onClick={() => setActive("Beneficiary")}
          >
            <IoIosPeople
              size={21}
              className="text-black/85 dark:text-[#CDE9DF]"
            />
            <h3 className="text-base font-semibold">Beneficiaries</h3>
          </Link>

          {/* Fund Wallet */}
          <Link
            to="/dashboard/fund-wallet"
            className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
              "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                realPathname === "fund-wallet",
              "hover:bg-gray-100 hover:dark:bg-gray-800":
                realPathname !== "fund-wallet",
            })}
            onClick={() => {
              setActive("Fund Wallet");
              setCloseTab(false);
            }}
          >
            <AiOutlineDollar
              size={21}
              className="text-black/85 dark:text-[#CDE9DF]"
            />
            <h3 className="text-base font-semibold">Fund Wallet</h3>
          </Link>

          {/* Transaction */}
          <Link
            to="/dashboard/transactions"
            className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
              "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                realPathname === "transactions",
              "hover:bg-gray-100 hover:dark:bg-gray-800":
                realPathname !== "transactions",
            })}
            onClick={() => setActive("Transactions")}
          >
            <IoReceiptOutline
              size={21}
              className="text-black/85 dark:text-[#CDE9DF]"
            />
            <h3 className="text-base font-semibold">Transactions</h3>
          </Link>

          {/* Settings */}
          <Link
            to="/dashboard/account"
            className={cn("flex items-center gap-2 rounded-lg px-3 py-2.5", {
              "text-primary bg-[#edf8f3] dark:bg-[#d7eded29] dark:text-white":
                realPathname === "account",
              "hover:bg-gray-100 hover:dark:bg-gray-800":
                realPathname !== "account",
            })}
            onClick={() => {
              setActive("Settings");
              setCloseTab(false);
            }}
          >
            <IoSettingsOutline
              size={21}
              className="text-black/85 dark:text-[#CDE9DF]"
            />
            <h3 className="text-base font-semibold">Settings</h3>
          </Link>
        </div>
      </div>

      <Footer />
    </nav>
  );
};
export default SideNavbar;
